module.exports = __webpack_public_path__ + "static/img/12.6870024.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/cards/12.png
// module id = 1B9r
// module chunks = 35